/**
 * Couleurs de marque Donoor — SOURCE UNIQUE côté JavaScript.
 *
 * Le bleu de marque existe à DEUX niveaux (il faut garder les deux alignés) :
 *  1. CSS : variable `--color-main` dans `app/assets/css/main.css` — utilisée
 *     par tout le style (classes Tailwind `text-(--color-main)`, `bg-main`,
 *     gradients inline `var(--color-main)`, SVG `fill="var(--color-main)"`).
 *  2. JS : cette constante — utilisée là où une variable CSS est IMPOSSIBLE
 *     parce que la valeur est lue par du JavaScript avant tout stylesheet :
 *     props de composants (`NuxtLoadingIndicator color=...`), valeurs de repli
 *     d'une couleur d'association (`primaryColor || BRAND_BLUE`), données de
 *     page passées en accent, etc.
 *
 * 👉 Pour changer le bleu du site : modifie `--color-main` dans main.css ET
 *    `BRAND_BLUE` ci-dessous avec la même valeur. Ce sont les 2 seuls endroits.
 */

/** Bleu de marque principal (miroir JS de `--color-main`). */
export const BRAND_BLUE = "#1f9afe";

/** Teinte foncée pour les dégradés (miroir JS de `--color-main-deep`). */
export const BRAND_BLUE_DEEP = "#1366b5";
